import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { start_offset_face } from '@frontend/scene';
import offset_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/offset.svg';
import { img } from '@phi/components';
import OffsetTooltip from './OffsetTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const OffsetIcon = offset_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Offset face';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.state.selected_edges_count !== 0
                || this.state.selected_vertices_count !== 0
                || (
                    this.state.selected_faces_count != 1
                    && !this.active
                );
        },

        active() {
            return this.state.offset_face_selecting_vertex
                || this.state.offset_face_dragging;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                start_offset_face();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 2,
            active: this.active,
            id: 'offset-button',
            wrapperId: 'offset-wrapper',
            tippy: 'bottom',
            onClick: this.onClick,
            help: 'offset_face',
        }, {
            label: () => 'Offset',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(offset_svg, this.alt),
            tooltip: OffsetTooltip,
        });
    },
});
